import React from 'react';
import { TabDescriptor } from '../types';

interface CommandeTabsProps {
  descriptors: TabDescriptor[];
  activeIndex: number;
  onSelect: (index: number) => void;
}

const tooltipFor = (tab: TabDescriptor): string => {
  if (tab.inactive) return 'Fonctionnalité en cours de développement';
  if (tab.disabled) return 'Non disponible dans ce statut';
  return '';
};

// Barre d'onglets presta : boutons CUSTOM calques sur OperationTabs (case acheteur), pour une
// parite VISUELLE exacte (soulignement orange #f97316, tooltips disabled/inactive). N'utilise
// PLUS le composant partage TabNav. Pilotee par descripteurs types : pas d'index magique, pas
// de regex ; disabled/inactive sont calcules en domaine puis lus tels quels.
const CommandeTabs: React.FC<CommandeTabsProps> = ({ descriptors, activeIndex, onSelect }) => (
  <div className="scbc__tab-nav">
    <div className="scbc__tab-nav-left">
      {descriptors.map((tab, index) => {
        const locked = tab.disabled || tab.inactive;
        const tooltip = tooltipFor(tab);
        const classes = ['scbc__tab-button'];
        if (index === activeIndex) classes.push('active');
        if (tab.inactive) classes.push('inactive');
        if (tab.disabled) classes.push('disabled');

        return (
          <button
            key={tab.key}
            type="button"
            className={classes.join(' ')}
            onClick={() => !locked && onSelect(index)}
            disabled={locked}
            title={tooltip}
            data-tooltip={tooltip}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default CommandeTabs;
